import axios from "axios";
import {
  ALL_PRODUCT_REQUEST,
  ALL_PRODUCT_SUCCESS,
  ALL_PRODUCT_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DETAILS_SUCCESS,
  NEW_REVIEW_SUCCESS,
  NEW_REVIEW_REQUEST,
  NEW_REVIEW_FAIL,
  ADMIN_PRODUCT_FAIL,
  ADMIN_PRODUCT_REQUEST,
  ADMIN_PRODUCT_SUCCESS,
  NEW_PRODUCT_REQUEST,
  NEW_PRODUCT_SUCCESS,
  NEW_PRODUCT_FAIL,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  ALL_REVIEW_REQUEST,
  ALL_REVIEW_SUCCESS,
  ALL_REVIEW_FAIL,
  DELETE_REVIEW_REQUEST,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_FAIL,
  CLEAR_ERRORS,
} from "../constants/productsConstatns";

/* =========================================================
   GET ALL PRODUCTS
========================================================= */
export const getProduct = (
  keyword = "",
  currentPage = 1,
  price = [0, 100000],
  category,
  ratings = 0
) => async (dispatch) => {
  try {
    dispatch({ type: ALL_PRODUCT_REQUEST });

    let link = `/api/v1/product?keyword=${keyword}&page=${currentPage}&price[gte]=${price[0]}&price[lte]=${price[1]}&ratings[gte]=${ratings}`;

    if (category) {
      link += `&category=${category}`;
    }

    const { data } = await axios.get(
      `https://style-in-backend.onrender.com${link}`
    );

    dispatch({
      type: ALL_PRODUCT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ALL_PRODUCT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};


/* =========================================================
   GET PRODUCT DETAILS (🔥 FIXED)
========================================================= */
export const getProductDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_DETAILS_REQUEST });

    const { data } = await axios.get(
      `https://style-in-backend.onrender.com/api/v1/product/${id}`
    );

    dispatch({
      type: PRODUCT_DETAILS_SUCCESS,
      payload: data.product, // ✅ CORRECT
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAILS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};


/* =========================================================
   CREATE / UPDATE REVIEW
========================================================= */
export const newReview = (reviewData) => async (dispatch) => {
  try {
    dispatch({ type: NEW_REVIEW_REQUEST });

    const { data } = await axios.put(
      `https://style-in-backend.onrender.com/api/v1/review/new`,
      reviewData,
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true, // 🔥 REQUIRED
      }
    );

    dispatch({
      type: NEW_REVIEW_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: NEW_REVIEW_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

/* =========================================================
   ADMIN: GET ALL PRODUCTS
========================================================= */
export const getAdminProducts = () => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_PRODUCT_REQUEST });

    const { data } = await axios.get(
      "https://style-in-backend.onrender.com/api/v1/admin/products",
      { withCredentials: true }
    );

    dispatch({
      type: ADMIN_PRODUCT_SUCCESS,
      payload: data.products,
    });
  } catch (error) {
    dispatch({
      type: ADMIN_PRODUCT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

/* =========================================================
   ADMIN: CREATE PRODUCT
========================================================= */
export const createProduct = (productData) => async (dispatch) => {
  try {
    dispatch({ type: NEW_PRODUCT_REQUEST });

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
    };

    const { data } = await axios.post(
      "https://style-in-backend.onrender.com/api/v1/admin/product/new",
      productData,
      {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: true,
  }
    );

    dispatch({
      type: NEW_PRODUCT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: NEW_PRODUCT_FAIL,
      payload:
        error.response?.data?.message || error.message,
    });
  }
};

/* =========================================================
   ADMIN: DELETE PRODUCT
========================================================= */
export const deleteProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PRODUCT_REQUEST });

    const { data } = await axios.delete(
  `https://style-in-backend.onrender.com/api/v1/admin/product/${id}`,
  { withCredentials: true }
);
    dispatch({
      type: DELETE_PRODUCT_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: DELETE_PRODUCT_FAIL,
      payload:
        error.response?.data?.message || error.message,
    });
  }
};

/* =========================================================
   ADMIN: UPDATE PRODUCT
========================================================= */
export const updateProduct = (id, productData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PRODUCT_REQUEST });

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
    };

    const { data } = await axios.put(
  `https://style-in-backend.onrender.com/api/v1/admin/product/${id}`,
  productData,
  {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: true,
  }
);
    dispatch({
      type: UPDATE_PRODUCT_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_PRODUCT_FAIL,
      payload:
        error.response?.data?.message || error.message,
    });
  }
};

/* =========================================================
   ADMIN: GET ALL REVIEWS
========================================================= */
export const getAllreviews = (productId) => async (dispatch) => {
  try {
    dispatch({ type: ALL_REVIEW_REQUEST });

    const { data } = await axios.get(
  `https://style-in-backend.onrender.com/api/v1/reviews?id=${productId}`,
  { withCredentials: true }
);


    dispatch({
      type: ALL_REVIEW_SUCCESS,
      payload: data.reviews,
    });
  } catch (error) {
    dispatch({
      type: ALL_REVIEW_FAIL,
      payload:
        error.response?.data?.message || error.message,
    });
  }
};

/* =========================================================
   ADMIN: DELETE REVIEW
========================================================= */
export const deleteProductReview =
  (reviewId, productId) => async (dispatch) => {
    try {
      dispatch({ type: DELETE_REVIEW_REQUEST });

      const { data } = await axios.delete(
  `https://style-in-backend.onrender.com/api/v1/product/reviews/delete?id=${reviewId}&productId=${productId}`,
  { withCredentials: true }
);

      dispatch({
        type: DELETE_REVIEW_SUCCESS,
        payload: data.success,
      });
    } catch (error) {
      dispatch({
        type: DELETE_REVIEW_FAIL,
        payload:
          error.response?.data?.message || error.message,
      });
    }
  };

/* =========================================================
   CLEAR ERRORS
========================================================= */
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
